import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { ShoppingCart } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function EducationSalesPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Vendas"
      description="Gerencie as vendas dos seus cursos."
      icon={ShoppingCart}
    />
  
    </MainLayout>);
}

